<div *ngIf="loading" class="loading-container">
  <mat-progress-spinner color="accent" mode="indeterminate">
  </mat-progress-spinner>
</div>

<div #siteContainer class="site-container">
  <div class="site-header">
		<app-splitter></app-splitter>
  </div>
</div>

